(() => {
  if (window.diNavigationReady) return;
  window.diNavigationReady = true;
  let header;
  let observer;
  const measureHeader = () => {
    if (!header) return;
    document.documentElement.style.setProperty('--di-header-offset', `${Math.ceil(header.getBoundingClientRect().height) + 16}px`);
  };
  const bindHeader = () => {
    const next = document.querySelector('.section-header') || document.querySelector('.pageheader');
    if (next === header) return;
    observer?.disconnect();
    header = next;
    if (header && 'ResizeObserver' in window) {
      observer = new ResizeObserver(measureHeader);
      observer.observe(header);
    }
    measureHeader();
  };
  bindHeader();
  if (!('ResizeObserver' in window)) window.addEventListener('resize', measureHeader, { passive: true });
  document.addEventListener('shopify:section:load', bindHeader);
  document.addEventListener('shopify:section:unload', event => {
    if (header && event.target.contains(header)) { observer?.disconnect(); header = null; }
  });
  document.addEventListener('keydown', event => {
    if (event.defaultPrevented || event.key !== 'Escape' || !document.body.classList.contains('reveal-mobile-nav')) return;
    const close = document.querySelector('.mobile-navigation-drawer .mobile-nav-toggle');
    if (!close) return;
    event.preventDefault();
    close.click();
    document.querySelector('.pageheader button.mobile-nav-toggle')?.focus({ preventScroll: true });
  });
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('.mobile-navigation-drawer [data-di-navigation-link]');
    if (!link || !document.body.classList.contains('reveal-mobile-nav') || link.target === '_blank' || link.hasAttribute('download')) return;
    const current = new URL(window.location.href);
    const destination = new URL(link.href, current);
    if (destination.origin !== current.origin || destination.pathname !== current.pathname || !destination.hash || (destination.search && destination.search !== current.search)) return;
    let target;
    try { target = document.getElementById(decodeURIComponent(destination.hash.slice(1))); } catch { return; }
    if (!target) return;
    const close = link.closest('.mobile-navigation-drawer').querySelector('.mobile-nav-toggle');
    if (!close) return;
    event.preventDefault();
    close.click();
    if (current.hash !== destination.hash) {
      current.hash = destination.hash;
      window.history.pushState(window.history.state, '', current);
    }
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
    target.scrollIntoView({ behavior: 'instant', block: 'start' });
  });
})();
